'use client';

import { useParams, useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { ChevronDownIcon } from '@/component/Icons/ChevronDownIcon';
import { Link } from '@/i18n/routing';
import { TABS } from './tabs';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const SitemapPage = () => {
  const { push } = useRouter();
  const params = useParams();
  const [currentTab = TABS[0].slug, page = 1] = params?.slug || [];
  const t = useTranslations();

  return (
    <div className="page-wrapper 3xl:space-y-3">
      <div className="container max-sm:py-8 sm:max-lg:py-[46px] lg:py-14 3xl:rounded-10">
        <div className="sm:hidden">
          <label htmlFor="tabs" className="sr-only">
            {t('form.tab.placeholder')}
          </label>
          <div className="grid">
            <ChevronDownIcon className="z-10 right-2 relative col-start-1 row-start-1 h-6 w-6 self-center justify-self-end forced-colors:hidden" />
            <select
              id="tabs"
              name="tabs"
              className="row-start-1 col-start-1 appearance-none w-full bg-slate-50 rounded-lg text-slate-600 text-sm font-medium border-slate-50 max-sm:px-3 max-sm:py-2 focus:border-slate-50 focus:outline-none focus:ring-slate-50"
              value={currentTab}
              onChange={(event) => push(`/sitemap/${event.target.value}`)}
            >
              {TABS.map((tab, index) => (
                <option key={tab.slug} value={tab.slug}>
                  {t(`main.sitemap.${tab.slug}`)}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="border-b border-slate-100 hidden sm:block">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {TABS.map((tab, index) => (
              <Link
                key={tab.slug}
                name={tab.slug}
                className={classNames(
                  tab.slug === currentTab
                    ? 'border-primary-800 text-primary-800'
                    : 'border-transparent text-slate-500 hover:border-slate-700 hover:text-slate-700',
                  'whitespace-nowrap border-b-2 sm:pb-4 text-base leading-normal cursor-pointer'
                )}
                aria-current={tab.slug === currentTab ? 'page' : undefined}
                href={`/sitemap/${tab.slug}`}
              >
                {t(`main.sitemap.${tab.slug}`)}
              </Link>
            ))}
          </nav>
        </div>
      </div>
      <div className="container max-sm:pb-8 sm:max-lg:pb-8 lg:pb-[46px] 3xl:pt-[46px] 3xl:rounded-10">
        {TABS.map((tab, index) => (
          <div
            key={tab.slug}
            className={`tab-item ${
              tab.slug === currentTab ? 'tab-active' : 'tab-hidden'
            }`}
          >
            {tab.slug === currentTab && tab.Component ? (
              <tab.Component tab={tab.slug} page={Number(page)} />
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SitemapPage;
